<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import ManagersSection from "@js/components/Sections/About/ManagersSection.vue";
import {Link} from "@inertiajs/vue3";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "AboutCompanyPage",
    components: {
        Link,
        RequisiteTable,
        Breadcrumbs,
        MobileTopBar,
        ManagersSection,
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <MobileTopBar/>
    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-bold mb-5">
            О компании
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <div class="grid grid-cols-1 gap-5">
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <p class="mb-4">
                        <strong>«Металлопрокат-1»</strong> — это опытная команда специалистов в области поставок и
                        продаж
                        металлопроката. Мы работаем на рынке с 2010 года и предлагаем клиентам широкий выбор металла:
                        от арматуры и уголков до листового и сортового проката.
                    </p>
                    <p class="mb-4">
                        Основная миссия нашей компании — обеспечить надёжные и своевременные поставки металла по
                        конкурентным ценам.
                        Мы сотрудничаем с ведущими производителями и напрямую поставляем продукцию на склады в Москве и
                        регионах.
                    </p>
                    <p class="mb-4">
                        Наши клиенты — это строительные компании, производственные предприятия, оптовые покупатели и
                        частные лица.
                        Мы ценим доверие и предоставляем гибкие условия сотрудничества, включая резку металла, доставку
                        и отгрузку со склада.
                    </p>
                    <button @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full mt-4 flex justify-center items-center text-center text-white hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                        Заказать обратный звонок
                    </button>
                </div>
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Наша продукция</h2>
                    <ul class="list-disc list-inside space-y-2">
                        <li><strong>Арматура, круг, квадрат, полоса</strong> — для монолитного и каркасного
                            строительства.
                        </li>
                        <li><strong>Листы горячекатаные и оцинкованные</strong> — для производства, кровли, обшивки и
                            ограждений.
                        </li>
                        <li><strong>Трубы профильные и круглые</strong> — стальные конструкции, заборы,
                            металлоконструкции.
                        </li>
                        <li><strong>Уголки, швеллера, балки</strong> — для силовых и несущих элементов конструкций.</li>
                    </ul>
                </div>

            </div>

            <div class="grid grid-cols-1 gap-5">
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Почему выбирают «Металлопрокат-1»</h2>
                    <ul class="list-disc list-inside space-y-2 mb-4">
                        <li><strong>Низкие цены на металлопрокат</strong> за счёт прямых поставок без посредников.</li>
                        <li><strong>Быстрая доставка</strong> по Москве, области и регионам России.</li>
                        <li><strong>Большой выбор в наличии</strong> на складах: более 1000 тонн металла ежедневно.</li>
                        <li><strong>Допуски, ГОСТ, сертификаты</strong> — вся продукция соответствует стандартам.</li>
                        <li><strong>Опт и розница</strong>: работаем с юрлицами и физлицами.</li>
                        <li><strong>Резка и упаковка</strong> под размеры клиента.</li>
                    </ul>
                </div>
                <div class="bg-grayBg p-5 md:p-8 rounded-3xl">
                    <h2 class="text-xl font-semibold mb-4">Логистика и доставка</h2>
                    <p class="mb-4">
                        Мы обеспечиваем <strong>оперативную доставку металлопроката</strong> по Москве, Московской
                        области и в регионы РФ. Собственный автопарк и налаженные логистические цепочки позволяют
                        доставлять металл точно в срок, даже в условиях срочного заказа.
                    </p>
                    <p class="mb-4">
                        Также доступен <strong>самовывоз со склада</strong> в Москве. Загрузка осуществляется быстро, с
                        учетом всех требований к упаковке и безопасности перевозки. При необходимости мы предоставим
                        консультации по расчёту объёмов, подбору транспорта и стоимости доставки.
                    </p>
                    <p>
                        Все маршруты планируются индивидуально — мы работаем как с частными заказами, так и с крупными
                        корпоративными поставками.
                    </p>
                    <Link :href="route('deliveryAndShipping')"
                          class="w-max mt-4 flex justify-center items-center text-center text-white hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                        Подробнее о доставке
                    </Link>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 gap-5">
            <ManagersSection/>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div class="border-2 border-baseColor rounded-3xl overflow-hidden">
                <RequisiteTable/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
